<template>
  <div class="p-b-10">
      <div class="platform-buttom-list" v-if="pageType === 'Detail'">
          <div :class="tagType===1? 'bottom-button-active':'bottom-button'" @click="handleChangeTag(1)">结算清单</div>
          <div :class="tagType===2? 'bottom-button-active':'bottom-button'" @click="handleChangeTag(2)">结算详情</div>
      </div>

      <component v-show="tagType === 1" :is="bottomListComponent"></component>
      <component v-if="tagType === 2" :is="bottomDetailComponent"></component>
  </div>
</template>

<script>
export default {
  components: {
    transactionList: () => import('../common/transactionList'),
    maintenanceList: () => import('../common/maintenanceList'),
    settlementDetail: () => import('../common/detailSettlement'),

    performanceList: () => import('../common/performanceList')
  },
  data () {
    return {
      tagType: 1,
      bottomListComponent: '',
      bottomDetailComponent: 'settlementDetail'
    }
  },
  created () {
    this.$store.commit('set_settlement_pageType', 'List')
    this.initPageData()
  },
  methods: {
    initPageData () {
      if (this.isAuth('settlement_transaction_view')) {
        this.tagType = 1
        this.bottomListComponent = 'transactionList'
        this.$store.commit('set_settlement_moduleType', 'transaction')
      } else if (this.isAuth('settlement_maintenance_view')) {
        this.tagType = 1
        this.bottomListComponent = 'maintenanceList'
        this.$store.commit('set_settlement_moduleType', 'maintenance')
      } else if (this.isAuth('performance_view')) {
        this.tagType = 1
        this.bottomListComponent = 'performanceList'
        this.$store.commit('set_settlement_moduleType', 'performance')
      }
    },
    handleChangeTag (val) {
      const componentName = val === 1 ? 'List' : 'Detail'
      this.$store.commit('set_settlement_pageType', componentName)
    }
  },
  computed: {
    pageType () {
      return this.$store.state.settlement.pageType
    },
    moduleType () {
      return this.$store.state.settlement.moduleType
    }
  },
  watch: {
    pageType (val) {
      if (val === 'Detail') {
        this.tagType = 2
      } else {
        this.tagType = 1
        this.bottomListComponent = this.moduleType + 'List'
      }
    },
    moduleType (val) {
      this.bottomListComponent = val + 'List'
    }

  }
}
</script>
